export type CommercialContactActions = {
  emailHref?: string;
  phoneHref?: string;
  whatsappHref?: string;
};

export function commercialContactActions(value: unknown): CommercialContactActions {
  if (typeof value !== "string") return {};
  const contact = value.trim();
  if (!contact) return {};
  if (contact.includes("@")) return { emailHref: `mailto:${contact}` };

  const digits = contact.replace(/\D/g, "");
  if (!digits) return {};
  const phone = contact.replace(/[^+0-9]/g, "");
  return {
    ...(phone ? { phoneHref: `tel:${phone}` } : {}),
    whatsappHref: `https://wa.me/${digits}`,
  };
}
